// extracted by mini-css-extract-plugin
export default {"content":"AcceptableUsePolicyPage_content__Rf+7Y","heading":"AcceptableUsePolicyPage_heading__rqyIL"};